import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { changePasswordApi } from "../../../utility/api/apiList";

import useAxios from "../../../hooks/useAxios";

import {
  showDangerAlert,
  showInfoAlert,
} from "../../../redux/actions/alert/alertActions";

import scrollToTop from "../../../libs/scrollToTop";

import UserChangePassComponent from "../../../components/private/user/userChangePassComponent";

export default function UserChangePassContainer() {
  const dispatch = useDispatch();
  useEffect(() => {
    document.title = "تغییر رمز";
    scrollToTop();
  }, []);

  const { isLoading, run } = useAxios({
    url: changePasswordApi,
    method: "put",
  });
  const handleChangePassword = (e) => {
    run(e)
      .then(() => {
        dispatch(showInfoAlert("رمز عبور جدید شما ثبت شد."));
      })
      .catch((error) => {
        dispatch(showDangerAlert("متاسفانه رمز تغییر نکرد."));
        Object.values(error.response.data).forEach((value) => {
          dispatch(showDangerAlert(value[0]));
        });
      });
  };

  return (
    <UserChangePassComponent
      handleChangePassword={handleChangePassword}
      loading={isLoading}
    />
  );
}
